export const STOCKHIDE_HELP_LINK = "https://help.stockhide.com/help";
export const STOCKHIDE_CONTACT_US_LINK = "https://stockhide.com/contact-us/";
export const STOCKHIDE_SUGGESTION_BOX_US_LINK = "https://stockhide.feedbear.com/boards/feature-requests";